import axios from 'axios'
import { Message } from 'element-ui'
import loginUtil from '@xpeng/login-util'
import { getLocale, intl } from '@xpeng/i18n'

const baseConfig = {
  timeout: 10000, // 请求超时时间 10s
  withCredentials: true // 允许跨域传递 cookie
}

const ajax = axios.create(baseConfig)
const ajaxRaw = axios.create(baseConfig)

const API_CODE = {
  SUCCESS: 200,
  UNLOGIN: 111300,
  UNAUTHORIZATION: 111301,
  un_authorization: 4001009
}

/** 未登录/未授权跳转；用于主 ajax 拦截器 */
function redirectIfUnloginOrUnauthorized(envelope) {
  if (!envelope || typeof envelope !== 'object') return false
  if (envelope.code == API_CODE.UNLOGIN) {
    loginUtil.redirectToLogin()
    return true
  }
  if (envelope.code == API_CODE.UNAUTHORIZATION || envelope.code == API_CODE.un_authorization) {
    loginUtil.redirectToAuthorization(intl.$t('审批管理平台'))
    return true
  }
  return false
}

/** ajaxRaw：跳转并 reject，供调用方走 catch；fallback 用于 HTTP 错误分支 */
function rejectIfUnloginOrUnauthorized(envelope, fallbackReject) {
  if (!envelope || typeof envelope !== 'object') return null
  if (envelope.code == API_CODE.UNLOGIN) {
    loginUtil.redirectToLogin()
    return Promise.reject(envelope.msg || fallbackReject || '用户未登录')
  }
  if (envelope.code == API_CODE.UNAUTHORIZATION || envelope.code == API_CODE.un_authorization) {
    loginUtil.redirectToAuthorization(intl.$t('审批管理平台'))
    return Promise.reject(envelope.msg || fallbackReject || '未授权')
  }
  return null
}

function attachCommonRequestInterceptors(instance) {
  instance.interceptors.request.use(
    config => {
      config.headers = config.headers || {}
      config.headers['Accept-Language'] = getLocale()
      return config
    },
    error => {
      Message({
        message: 'HTTP Request Error',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(error)
    }
  )
}

attachCommonRequestInterceptors(ajax)
attachCommonRequestInterceptors(ajaxRaw)

function attachRawLoginResponseInterceptor(instance) {
  instance.interceptors.response.use(
    response => {
      const p = rejectIfUnloginOrUnauthorized(response.data)
      if (p) return p
      return response
    },
    error => {
      const data = error.response && error.response.data
      const p = rejectIfUnloginOrUnauthorized(data, error)
      if (p) return p
      return Promise.reject(error)
    }
  )
}

attachRawLoginResponseInterceptor(ajaxRaw)

ajax.interceptors.response.use(
  response => {
    let res = response.data

    const { code } = res
    if (code === API_CODE.SUCCESS) {
      return Promise.resolve(res.data)
    }

    if (redirectIfUnloginOrUnauthorized(res)) {
      return Promise.reject(res.msg || 'Network Error')
    }

    return Promise.reject(res.msg)
  },
  error => {
    console.log(error)
    return Promise.reject(error.message)
  }
)

export { ajaxRaw }
export default ajax
